/**
 * @desc 创建库存调整单
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  body: defs.fulfilment.StockAdjustmentMasterRequestParamsDto,
  options?: any,
) {
  return updateResponse(
    http(URL + `/stockAdjustmentMaster/establish`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
